import { Component, Input } from '@angular/core';

@Component({
  selector: 'afoone-boolean-indicator',
  templateUrl: './boolean-indicator.component.html',
  styleUrls: ['./boolean-indicator.component.css'],
})
export class BooleanIndicatorComponent {
  @Input() value: boolean | 'Y' | 'N' = false;
}
